import React from 'react';
import { ItemRefundActivity } from '../../../../../model/activity';
import { useData } from '../../../../../model/data';
import './ActivityItems.css';
import { OutgoingItemGroup, IncomingItemGroup } from '../../../../../model/order';
import { compact } from 'lodash';

export function RefundActivity({ activity }: { activity: ItemRefundActivity }): JSX.Element | null {
  const orderItems = useData((db) =>
    db.table('orders').where((order) => {
      const activityOrderId = activity.modifications.items[0].id;
      const orders = order.itemGroups?.map((item) => item.id).includes(activityOrderId);
      return !!orders;
    })
  )?.[0]?.itemGroups;

  const modificationItems: Array<OutgoingItemGroup | IncomingItemGroup> = compact(
    activity.modifications?.items?.map((item) => orderItems?.find((i) => i.id === item.id))
  );

  const activityItems = new Set<string>();

  modificationItems?.forEach((modItem) => {
    if (modItem) {
      activityItems.add(
        [modItem.productVariant?.sku, modItem.product?.name, modItem.productVariant?.description]
          .filter(Boolean)
          .join(' - ')
      );
    }
  });

  return (
    <ul>
      {Array.from(activityItems).map((ai) => (
        <li key={ai}>{ai}</li>
      ))}
    </ul>
  );
}
